import axios from "axios"


// DEV_LOCAL : l'API est appelee sur l'hote depuis lequel la page est servie
// (localhost sur le Mac, 192.168.1.x depuis le poste de Nawal). Une URL figee
// casse le cookie de session des que l'on consulte par un autre hote, et la
// box redistribue les IP (le Mac est passe de .16 a .147 le 31/07).
// En prod, REACT_APP_APIS_BACK est defini au build et garde la priorite.
const hoteLocal = (port) => (typeof window !== "undefined"
  ? `https://${window.location.hostname}:${port}` : `https://localhost:${port}`)
export const GLB_URL_APIS = process.env.REACT_APP_APIS_BACK || hoteLocal(7443)
//export const GLB_URL_APIS = process.env.REACT_APP_APIS_BACK || 'https://thelabapis.risinguparis.com'

export const GLB_URL_THESCAN = process.env.REACT_APP_THESCAN_URL || hoteLocal(8000)

// 27/09/2026 : délai maximal de l'envoi d'une réponse de candidat (repondreSequence).
export const DELAI_REPONDRE_MS = 20000



export default {
  /* AUTH */
  askForNewPasswordEmail : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/askForNewPasswordEmail", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  checkResetPsswd : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/checkResetPsswd", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  setPsswd: async (vals) => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/setPsswd", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  loginUser : async vals => {
    try {
      let valuesToSend = {
        ...vals,
        type : "RisUpTheLab2025"
      }
      const res = await axios.post(GLB_URL_APIS + "/auth/login", valuesToSend, {
        withCredentials: true,
      })
      if (res.data.message == "signin") {

      } else {

      }
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  // 02/09/2026 : cette fonction renvoyait `undefined` aussi bien quand le serveur
  // repondait « tu n'es plus connecte » que quand il ne repondait pas du tout.
  // Les deux appelants en concluaient une deconnexion : un wifi qui saute deux
  // secondes, un tunnel, un redemarrage du back, et l'utilisateur se prenait
  // l'ecran « Vous avez ete deconnecte » alors que sa session etait valide.
  // On distingue desormais les deux cas.
  // Deconnexion serveur. THE SCAN a recu cet appel ; THE LAB ne l'avait jamais
  // eu : sa deconnexion se contentait de supprimer le cookie dans le navigateur,
  // et la session restait OUVERTE cote serveur.
  postLogout : async () => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/auth/logout", {}, { withCredentials: true })
      return res.data
    } catch (err) { return null }
  },
  getLoginStatus: async () => {
    try {
      const res = await axios.get(GLB_URL_APIS + "/auth/status", {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      console.log(err)
      // Pas de reponse du serveur : on ne sait rien de la session.
      // Une reponse HTTP, meme 401 ou 500, n'est pas une panne reseau.
      // 25/09/2026 : un 5xx (serveur ou base momentanement indisponible, 503
      // depuis B40) ne dit rien de la session non plus : ne pas deconnecter.
      return { reseauIndisponible : !err?.response || err.response.status >= 500 }
    }
  },

  getAllInfos: async (id) => {
    let tmpID = null
    if (id) {
      tmpID = id
    }
    try {
      const res = await axios.post(GLB_URL_APIS + "/formation/getAllInfos", {id : tmpID}, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },
  /* END AUTH */

  /* CLIENT DASHBOARD */
  completionAndSoftSkills : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/clientAdmin/completionAndSoftSkills", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      console.log(err)
      /* Relecture finale 02/09 : renvoyer `undefined` faisait conclure aux
         ecrans « Donnees non disponibles » alors que le serveur n'avait pas
         repondu. Un creux reseau affichait donc un mensonge a l'admin client.
         On distingue les deux cas, comme pour getLoginStatus. */
      return { reseauIndisponible : !err?.response || err.response.status >= 500 } // 503 = indisponible (25/09)
    }
  },

  clientAdminSuivi : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/clientAdmin/suivi", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      console.log(err)
      /* Relecture finale 02/09 : renvoyer `undefined` faisait conclure aux
         ecrans « Donnees non disponibles » alors que le serveur n'avait pas
         repondu. Un creux reseau affichait donc un mensonge a l'admin client.
         On distingue les deux cas, comme pour getLoginStatus. */
      return { reseauIndisponible : !err?.response || err.response.status >= 500 } // 503 = indisponible (25/09)
    }
  },

  clientAdminMapping : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/clientAdmin/mapping", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      console.log(err)
      /* Relecture finale 02/09 : renvoyer `undefined` faisait conclure aux
         ecrans « Donnees non disponibles » alors que le serveur n'avait pas
         repondu. Un creux reseau affichait donc un mensonge a l'admin client.
         On distingue les deux cas, comme pour getLoginStatus. */
      return { reseauIndisponible : !err?.response || err.response.status >= 500 } // 503 = indisponible (25/09)
    }
  },
  /* END CLIENT DASHBOARD */

  /* ACCOUNT */
  updateAccount : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/updateAccount", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },
  updatePassword : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/updatePassword", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  onBoard : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/onBoardingAll", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  checkGroupCode : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/groupe/checkCode", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  register : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/register", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  checkAdminRegister : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/checkAdminRegister", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  adminRegister : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/adminRegister", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },
  /* END ACCOUNT */

  /* FORMATION */
  editFormationResult : async (elementID, type, vals) => {
    let values = {
      elementID : elementID,
      vals : vals
    }
    try {
      const res = await axios.post(GLB_URL_APIS + "/formation/"+type+"/saveResult", values, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      /* 27/09/2026, chantier « scores côté serveur » (relecture, MOYEN 3). Pour
         un candidat THE SCAN, le serveur n'écrit une réponse qu'une fois : une
         réponse DIFFÉRENTE déjà en base (autre onglet, par exemple) rend 409
         avec `dejaRepondu`. Ce n'est pas une panne, c'est « la base fait foi » :
         on le dit à saveUserFormation, qui resynchronise au lieu d'alerter en
         boucle. Réponse attendue, donc pas de console.error. */
      if (err?.response?.status === 409 && err?.response?.data?.dejaRepondu === true) {
        return { error: true, dejaRepondu: true, sessionExpiree: false }
      }
      // Sauvegarde de résultat apprenant : on REMONTE l'échec au lieu de l'avaler,
      // pour que saveUserFormation ne le prenne pas pour un succès (perte silencieuse).
      console.error("editFormationResult échec :", err?.message || err)
      // B37 (25/09/2026) : 401 = session expiree, pas panne de connexion. Le
      // contexte le dit a l'apprenant et le renvoie se reconnecter.
      return { error: true, sessionExpiree: err?.response?.status === 401 }
    }
  },

  /* 27/09/2026, chantier « scores côté serveur » (décision d'Hicham). Pour un
     candidat THE SCAN, le serveur ne livre plus les bonnes réponses avant la
     réponse : le lecteur lui envoie le choix, le serveur l'enregistre et rend la
     correction de cet écran. Chaque refus a un sens que l'écran doit distinguer,
     d'où un retour plus riche que celui de editFormationResult :
     - 409 : une AUTRE réponse est déjà enregistrée. Le corps porte la réponse
       enregistrée et sa correction : l'écran les affiche à la place du choix
       coché, on les rend donc telles quelles, avec `dejaRepondu` ;
     - 401 : session expirée, même lecture que editFormationResult (B37) ;
     - 5xx ou aucune réponse : serveur indisponible, même lecture que
       getLoginStatus (503 depuis B40) ;
     - tout autre refus (400, 403, ou 404 d'un serveur qui n'a pas encore la
       route) : échec simple, l'écran propose de réessayer.
     27/09/2026 (relecture) : DÉLAI MAXIMAL de 20 s. Pendant l'envoi, le bouton
     est désactivé et le choix figé : sans délai, un serveur qui ne répond
     jamais laissait l'écran bloqué. Passé ce délai, axios abandonne la requête,
     l'appel rend « indisponible » (pas de réponse) et l'écran redevient
     utilisable avec le message d'échec. Si le serveur avait tout de même
     enregistré la réponse, le nouvel essai reçoit la même réponse, ou un 409
     qui montre celle enregistrée. */
  repondreSequence : async (elementID, userChoice) => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/formation/sequence/repondre", {
        elementID : elementID,
        vals : { userChoice : userChoice },
      }, {
        withCredentials: true,
        timeout: DELAI_REPONDRE_MS,
      })
      return res.data
    } catch (err) {
      const statut = err?.response?.status
      // 27/09/2026 (relecture) : le 409 est une reponse attendue, pas une
      // panne ; on ne le journalise donc pas comme une erreur.
      if (statut === 409) {
        return { ...(err?.response?.data || {}), error: true, dejaRepondu: true }
      }
      console.error("repondreSequence échec :", err?.message || err)
      return {
        error: true,
        sessionExpiree: statut === 401,
        reseauIndisponible: !err?.response || statut >= 500,
      }
    }
  },

  getCertifInfos : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/formation/getCertifInfos", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },
  /* END FORMATION */

  /* SUPER ADMIN */
  getSuperAdminGroupes : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/groupe/admin", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getSuperAdminContents : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/content/admin", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getSuperAdminAdminClients : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/admin/adminclient", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getSuperAdminEcoles : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/ecoles/admin", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getMailingTemplates : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/mailing/templates", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getMailingByGroupAndContent : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/mailing", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addMailing : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/mailing/add", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  editMailing : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/mailing/edit", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  editMailingPlan : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/mailing/planEdit", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  removeMailing : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/mailing/remove", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  forceSendingMailing : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/mailing/forceSending", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  testSendingMailing : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/mailing/testSending", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addMailingTemplate : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/mailing/templates/add", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  removeMailingTemplate : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/mailing/templates/remove", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  archiveOrNotGroupe : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/groupe/admin/archiveOrNot", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  resetGroupLogo : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/groupe/admin/resetLogo", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addGroupe : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/groupe/admin/add", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      // Un refus du back (400 champs manquants, 409 code deja pris) porte son
      // motif dans le corps : on le remonte a l'appelant au lieu de le perdre.
      console.log(err)
      return err?.response?.data || { error: true }
    }
  },

  editGroupe : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/groupe/admin/edit", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      console.log(err)
      return err?.response?.data || { error: true }
    }
  },

  getGroupeUsers : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/groupe/admin/users", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  createSimuForGroupe : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/groupe/admin/createSimu", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  saveGroupeCertification : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/groupe/admin/saveCertification", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getGroupeUsersResults : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/groupe/admin/usersResults", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getContentByIdForAdmin : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/content/admin/getOneById", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addEcole : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/ecoles/admin/add", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  editEcole : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/ecoles/admin/edit", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addCampusForEcole : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/ecoles/admin/campus/add", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  deleteCampusForEcole : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/ecoles/admin/campus/delete", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  resendInvitForAdminClient : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/admin/adminclient/resendInvit", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addAdminClient : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/admin/adminclient/add", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  editAdminClient : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/admin/adminclient/edit", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addContent : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/content/admin/add", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  editContent : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/content/admin/content/edit", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  checkForChangeContentType : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/content/admin/checkForChangeContentType", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  archiveOrNotContent : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/content/admin/archiveOrNot", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  editFormationElement : async (type, vals) => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/content/admin/"+type+"/edit", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      // Sauvegarde de contenu (super-admin) : on REMONTE l'échec au lieu de
      // l'avaler, pour que saveAdminContent ne remplace pas les modifs de Nawal
      // par la version serveur non modifiée (perte silencieuse).
      console.error("editFormationElement échec :", err?.message || err)
      return { error: true }
    }
  },

  addFormationElement : async (type, idToAdd, vals) => {
    let values = {idToAdd : idToAdd, vals : vals}
    try {
      const res = await axios.post(GLB_URL_APIS + "/content/admin/"+type+"/add", values, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  removeFormationElement : async (type, idToRemove) => {
    let vals = {id : idToRemove}
    try {
      const res = await axios.post(GLB_URL_APIS + "/content/admin/"+type+"/remove", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },
  /* END SUPER ADMIN */

  /* SUPPORT — chat maison, remplace Crisp.
     Volontairement appelable sans session : le cas d'usage numero un est
     quelqu'un bloque au login. Le back plafonne par IP. */
  supportMessage : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/support/message", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      // On rend l'erreur au composant au lieu de l'avaler : il doit distinguer
      // une limite de debit (429) d'une panne, sinon la personne reessaie pour rien.
      return err.response?.data || { error: true, data: "reseau" }
    }
  },

  supportFil : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/support/fil", vals, { withCredentials: true })
      return res.data
    } catch (err) {
      return null // echec de sondage benin : le widget reessaiera
    }
  },

  /* SUPPORT ADMIN (espace equipe) */
  supportAdminListe : async (vals = {}) => {
    try { const res = await axios.post(GLB_URL_APIS + "/support/admin/liste", vals, { withCredentials: true }); return res.data }
    catch (err) { return err.response?.data || { error: true } }
  },
  supportAdminConversation : async vals => {
    try { const res = await axios.post(GLB_URL_APIS + "/support/admin/conversation", vals, { withCredentials: true }); return res.data }
    catch (err) { return err.response?.data || { error: true } }
  },
  supportAdminRepondre : async vals => {
    try { const res = await axios.post(GLB_URL_APIS + "/support/admin/repondre", vals, { withCredentials: true }); return res.data }
    catch (err) { return err.response?.data || { error: true } }
  },
  supportAdminTraiter : async vals => {
    try { const res = await axios.post(GLB_URL_APIS + "/support/admin/traiter", vals, { withCredentials: true }); return res.data }
    catch (err) { return err.response?.data || { error: true } }
  },
}
